module.exports = import("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap");;